import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import NotesRender from './NotesRender'

import BodyText from 'LuxKit/Typography/BodyText'

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
`

type Props = {
  notes?: string
}

function SummaryAdditionalNotes({ notes }: Props) {
  const intl = useIntl()
  if (!notes) return null

  const additionalNotesLabel = intl.formatMessage({
    id: 'GxOjUzwVODUPdku9gwPm',
    defaultMessage: 'Additional notes',
    description: 'Heading for additional notes section in trip item summary',
  })

  return (
    <Item>
      <BodyText weight="bold" variant="large">
        {additionalNotesLabel}
      </BodyText>
      <NotesRender content={notes} type="compact" fontSize="large" />
    </Item>
  )
}

export default SummaryAdditionalNotes
